import { useState } from '#app';

export const useConfig = () => {
  return useState('runtime-config') as Ref<{
    public: {
      apiUrl: string;
      lemonwayEnv: string;
      webkitUrl: string;
      headwayId: string;
      wootricId: string;
      jimoProjectId?: string;
      maxApprovalWorkflowValidators: number;
      appName: string;
    };
  }>;
};
